export default function CardIcon({ name }: { name: string }) {
  return (
    <div className="w-10 h-10 rounded-lg bg-[#7c3aed]/15 border border-[#7c3aed]/25 flex items-center justify-center text-[#d2bbff] shrink-0">
      <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>{name}</span>
    </div>
  )
}
